// extracted by mini-css-extract-plugin
export default {"container":"style_container__D0dUX","content":"style_content__8qsYk","title":"style_title__--WKH","title_header":"style_title_header__KoXOZ","title_inner":"style_title_inner__FLyTn"};